
import Vue from "vue"
import NavOurServicesMixin from "~/mixins/navOurServices"

export default Vue.extend({
  name: "NavOurServicesEn",
  extends: NavOurServicesMixin
})
